"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSyncCompleted = isSyncCompleted;
exports.isSyncFailed = isSyncFailed;
exports.isSyncInProgress = isSyncInProgress;
exports.isSyncWaiting = isSyncWaiting;
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
function isSyncStatus(actualSyncStatus, expectedSyncStatus) {
    if (actualSyncStatus === expectedSyncStatus) {
        return true;
    }
    return false;
}
function isSyncCompleted(status) {
    return isSyncStatus(status, sonar_ts_constants_1.ImportStatus.Completed);
}
function isSyncFailed(status) {
    return isSyncStatus(status, sonar_ts_constants_1.ImportStatus.Failed);
}
function isSyncInProgress(status) {
    return isSyncStatus(status, sonar_ts_constants_1.ImportStatus.InProgress);
}
function isSyncWaiting(status) {
    return isSyncStatus(status, sonar_ts_constants_1.ImportStatus.Waiting);
}
//# sourceMappingURL=lib.js.map